import { useState, useEffect } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put, get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import './CustomerModals.scss'

function EditCustomer({ fetchUser, setShowEditCustomer, userData }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [stations, setStations] = useState<any[]>([])
  const [formInput, setFormInput] = useState({
    firstname: userData?.firstname || '',
    lastname: userData?.lastname || '',
    email: userData?.email || '',
    phone: userData?.phonenumber || '',
    closestStation: userData?.closestStation || '',
  })

  useEffect(() => {
    get('utils/stations')
      .then((result: any) => {
        if (result.status === 200) {
          setStations(result.data || [])
        }
      })
      .catch(() => {})
  }, [])

  async function updateDebt() {
    const firstname = formInput.firstname.trim()
    const lastname = formInput.lastname.trim()
    if (!firstname || !lastname) {
      notify('warn', 'First name and last name cannot be empty')
      return
    }
    const data = {
      firstname,
      lastname,
      email: formInput.email.toLocaleLowerCase(),
      phonenumber: formInput.phone,
      closestStation: formInput.closestStation,
    }
    setCancelLoading(true)
    put(`admin/user/${id}`, data)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'User Updated')
          setShowEditCustomer(false)
          fetchUser()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className='modal-icon icon-blue'>
            <Icon icon='mdi:account-edit-outline' />
          </div>
          <h2>Edit User Details</h2>
          <p>Update the name and contact details for this user.</p>
        </div>

        <div className='form-group'>
          <label>First Name</label>
          <input
            type='text'
            placeholder='Enter first name'
            maxLength={50}
            value={formInput.firstname}
            onChange={(e) =>
              setFormInput({ ...formInput, firstname: e.target.value })
            }
          />
        </div>

        <div className='form-group'>
          <label>Last Name</label>
          <input
            type='text'
            placeholder='Enter last name'
            maxLength={50}
            value={formInput.lastname}
            onChange={(e) =>
              setFormInput({ ...formInput, lastname: e.target.value })
            }
          />
        </div>

        <div className='form-group'>
          <label>Email Address</label>
          <input
            type='email'
            placeholder='Enter email'
            value={formInput.email}
            onChange={(e) =>
              setFormInput({ ...formInput, email: e.target.value })
            }
          />
        </div>

        <div className='form-group'>
          <label>Phone Number</label>
          <input
            type='tel'
            placeholder='Enter phone number'
            value={formInput.phone}
            onChange={(e) =>
              setFormInput({ ...formInput, phone: e.target.value })
            }
          />
        </div>

        <div className='form-group'>
          <label>Closest Station</label>
          <select
            value={formInput.closestStation}
            onChange={(e) =>
              setFormInput({ ...formInput, closestStation: e.target.value })
            }
          >
            <option value=''>No station selected</option>
            {stations.map((station: any) => (
              <option key={station.name} value={station.name}>
                {station.name}
              </option>
            ))}
          </select>
        </div>

        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button
              className='btn-cancel'
              onClick={() => setShowEditCustomer(false)}
            >
              Cancel
            </button>
            <button className='btn-proceed' onClick={updateDebt}>
              Save Changes
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default EditCustomer
